import React, { createContext, useContext, useEffect, useRef } from "react";
import useWebSocket from "react-use-websocket";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  // Use environment variable or default to local backend
  const WS_ENDPOINT_URL = process.env.REACT_APP_WS_URL || "ws://localhost:3013/ws/";
  const JWT_TOKEN = localStorage.getItem("token");
  
  const { sendMessage, lastMessage, readyState } = useWebSocket(WS_ENDPOINT_URL, {
    protocols: JWT_TOKEN ? [JWT_TOKEN] : [], // ✅ Send JWT for authentication
    shouldReconnect: () => true, // ✅ Auto-reconnect
    reconnectAttempts: 10,
    reconnectInterval: 3000,
  });

  // Send a ping every 2 minutes
  const pingInterval = useRef(null);
  useEffect(() => {
    if (readyState === 1) {
      console.log("✅ WebSocket Connected to", WS_ENDPOINT_URL);
      pingInterval.current = setInterval(() => {
        sendMessage(JSON.stringify({ type: "ping" }));
        console.log("📡 Sending Ping");
      }, 120000);
    }
    return () => clearInterval(pingInterval.current);
  }, [readyState, sendMessage, WS_ENDPOINT_URL]);

  return (
    <WebSocketContext.Provider value={{ sendMessage, lastMessage, readyState }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocketContext = () => useContext(WebSocketContext);
